export default {
  QUESTION_TIME_GROUP_ID: 624,
  QUESTION_EXISTING_TOILET_IN_REPLACE_BUNNINGS: 626,
  QUESTION_ANSWER_YES_EXISTING_TOILET_IN_REPLACE_BUNNINGS: '2746',
  COOKIE_TOKEN: 's_token'
};
